import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FullComponent } from './shared/layout/full/full.component';
import { HomePageComponent } from './modules/home-page/home-page.component';
import { TestComponent } from './modules/test/test.component';
import { AutomlLoginComponent } from './modules/flow-builder/automl-login/automl-login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AutoMlOverviewComponent } from './modules/flow-builder/auto-ml-overview/auto-ml-overview.component';

const routes: Routes = [
  {
    path:'',
    redirectTo:'auto-ml',
    pathMatch:'full'
  },
  {
    path:'home',
    component: HomePageComponent,
    canActivate:[AuthGuard],
    data: {
      title: 'ETL - Flow Builder - Home',
      descrption: 'ETL - Flow Builder Home Page',
    }
  },
  {
    path:'login',
    component: AutomlLoginComponent,
  },
  {
    path: 'main',
    component: FullComponent,
    canActivate:[AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
      },
    ],
  },
  {
    path: 'flow-builder',
    canActivate:[AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/flow-builder/flow-builder.module').then((m) => m.FlowBuilderModule),
      },
    ],
    data: {
      title: 'ETL - Flow Builder - Main',
      descrption: 'ETL - Flow Builder Main Page',
    }
  },
  {
    path: 'auto-ml',
    canActivate:[AuthGuard],
    children: [
      {
        path: '',
        component:AutoMlOverviewComponent
      },
    ],
    data: {
      title: 'ETL - Flow Builder - Main',
      descrption: 'ETL - Flow Builder Main Page',
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
